<template>

  <modal-layout
    :bgShow="refuseModal.bg"
    :modalShow="refuseModal.modal"
    @close="close">

    <div
      class="refuse-modal">
      <div
        class="refuse-modal__title">
        <div>
          Укажите причину отказа выкупа
        </div>
        <a
          href="/close"
          @click.prevent="close()">
          <img
            src="@/../static/img/icons/close.svg">
        </a>
      </div>
      <div
        class="refuse-modal__body">

        <div
          class="list">
          <div
            class="list-item"
            v-for="(item, i) in refusals" :key="i">
            <input
              type="radio"
              v-model="refusal"
              :value="item.id"
              :id="`item_${i}`">
            <label
              :for="`item_${i}`"
              class="label">
              <span class="label-btn"></span>
              <span
                class="label-text">
                {{ item.name }}
              </span>
            </label>
          </div>
        </div>

      </div>
      <div
        class="refuse-modal__footer">
        <button
          class="btn cancel"
          @click.prevent="cancel()">
          Отказаться
        </button>
      </div>
    </div>

  </modal-layout>

</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import ModalLayout from './ModalLayout';

export default {
  components: {
    ModalLayout,
  },
  data() {
    return {
      refusal: '',
    }
  },
  computed: {
    ...mapState('layout', ['refuseModal']),
    ...mapState('buymodels', ['refusals']),
  },
  mounted() {
    this.getAllRefused();
  },
  methods: {
    ...mapActions('buymodels', ['getAllRefused']),
    ...mapMutations('layout', ['SET_REFUSE_MODAL']),

    close() {
      this.SET_REFUSE_MODAL({bg: false, modal: false})
    },

    cancel() {
      this.$emit('cancel', { id: this.refusal });
      this.close();
    }
  },
}
</script>

<style lang="sass">
  @import '@/styles/components/modals/refuse-modal.sass'
</style>
